import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';
import { PwaInstallService } from '../../services/pwa-install.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pwa-install-banner',
  templateUrl: './pwa-install-banner.component.html',
  styleUrls: ['./pwa-install-banner.component.scss'],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class PwaInstallBannerComponent implements OnInit, OnDestroy {
  showBanner = false;
  isInstallable = false;
  isIOS = false;
  isStandalone = false;
  private subscription: Subscription = new Subscription();

  constructor(private pwaInstallService: PwaInstallService) {}

  ngOnInit(): void {
    this.checkDeviceAndInstallability();
    this.subscribeToInstallabilityChanges();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private checkDeviceAndInstallability(): void {
    this.isIOS = this.pwaInstallService.isIOS();
    this.isStandalone = this.pwaInstallService.isStandalone();
    this.isInstallable = this.pwaInstallService.isInstallable();
    
    // Usa la logica del servizio per determinare se mostrare il banner
    this.showBanner = this.pwaInstallService.shouldShowBanner();
  }

  private subscribeToInstallabilityChanges(): void {
    this.subscription.add(
      this.pwaInstallService.installabilityChanged$.subscribe(() => {
        this.checkDeviceAndInstallability();
      })
    );
  }

  async onInstallClick(): Promise<void> {
    if (this.isIOS) {
      // Per iOS mostra le istruzioni
      this.showIOSInstructions();
    } else if (this.isInstallable) {
      // Per altri browser usa l'API nativa
      const installed = await this.pwaInstallService.promptInstall();
      if (installed) {
        this.hideBanner();
      }
    }
  }

  onCloseClick(): void {
    // Nasconde il banner solo per questa sessione
    this.pwaInstallService.dismissBannerForSession();
    this.hideBanner();
  }

  private hideBanner(): void {
    this.showBanner = false;
  }

  private showIOSInstructions(): void {
    // Mostra un modal o alert con le istruzioni per iOS
    const message = `Per installare questa app su iOS:
    
1. Tocca l'icona di condivisione (quadrato con freccia verso l'alto) nella barra degli strumenti di Safari
2. Scorri verso il basso e tocca "Aggiungi alla schermata Home"
3. Tocca "Aggiungi" nell'angolo in alto a destra`;

    alert(message);
  }

  getBrowserName(): string {
    return this.pwaInstallService.getBrowserName();
  }
}